import React from 'react';
import { Grid, Button, Input } from '@roo/roo';

import { FORM_TIP, IncrementFeeItem } from '../api';
import './SignFieldArray.scss';

const { Row, Col } = Grid;

interface IProps {
    value?: IncrementFeeItem[];
    earningsThreshold?: number;
    handleChange: (value: IncrementFeeItem[]) => void;
    periodType: FORM_TIP;
}

export default class FieldArray extends React.Component<IProps> {
    handleChange(index: number, key: keyof IncrementFeeItem, e: any) {
        if (!this.props.value) {
            return;
        }
        const arr = this.props.value.slice(0);
        let { value } = e.target;
        if (key === 'ladderThreshold') {
            if (!/^\d*$/.test(value)) {
                return;
            }
            if (Number(value) > 20000000) {
                value = '20000000';
            }
        } else {
            if (!/^\d*\.?\d*$/.test(value)) {
                return;
            }
            if (Number(value) > 20) {
                value = '20.00';
            } else {
                const _arr = value.split('.');
                if (_arr.length > 2 || (_arr[1] && _arr[1].length > 2)) {
                    return;
                }
            }
        }

        arr[index][key] = value;
        this.props.handleChange(arr);
    }

    handleAdd = (index: number) => {
        if (!this.props.value) {
            return;
        }
        const arr = this.props.value.slice(0);
        arr.splice(index + 1, 0, { ladderThreshold: '', ladderCommissionRate: '' });
        this.props.handleChange(arr);
    };

    handleDelete = (index: number) => {
        if (!this.props.value) {
            return;
        }
        const arr = this.props.value.slice(0);
        arr.splice(index, 1);
        this.props.handleChange(arr);
    };

    render() {
        const { value = [], earningsThreshold, periodType } = this.props;
        return (
            <div>
                {value && value.length !== 0 ? (
                    value.map((v, i) => (
                        <Row className="list-row" key={i}>
                            <Col className="col-clear" span={2}>
                                <Input
                                    disabled
                                    value={`${
                                        i === 0 ? earningsThreshold : value[i - 1].ladderThreshold
                                    }`}
                                />
                            </Col>
                            <Col className="col-clear-all" span={1.2}>
                                &lt;= 商家实收 &lt;
                            </Col>
                            <Col className="col-clear-all" span={2}>
                                <Input
                                    type="number"
                                    value={`${v.ladderThreshold}`}
                                    onChange={e => this.handleChange(i, 'ladderThreshold', e)}
                                />
                            </Col>
                            <Col className="col-clear-all" span={0.7}>
                                {`元/${periodType === FORM_TIP.PERIOD_M ? '月' : '日'}`}，
                            </Col>
                            <Col className="col-clear-all" span={1.5}>
                                增量部分抽佣比例
                            </Col>
                            <Col className="col-clear-all" span={1}>
                                <Input
                                    type="text"
                                    className="last-input"
                                    value={`${v.ladderCommissionRate}`}
                                    onChange={e => this.handleChange(i, 'ladderCommissionRate', e)}
                                />
                            </Col>
                            <Col className="col-clear-left" span={0.5}>
                                %
                            </Col>
                            <Col className="col-clear-all" span={2}>
                                {value.length >= 5 ? null : (
                                    <Button className="feild-btn" onClick={() => this.handleAdd(i)}>
                                        +
                                    </Button>
                                )}
                                {i === value.length - 1 && i > 0 ? (
                                    <Button
                                        className="feild-btn"
                                        onClick={() => this.handleDelete(i)}
                                    >
                                        －
                                    </Button>
                                ) : null}
                            </Col>
                        </Row>
                    ))
                ) : (
                    <Row>
                        <Col className="col-clear" span={2}>
                            <Input disabled value="实收门槛" />
                        </Col>
                        <Col className="col-clear-all" span={1.2}>
                            &lt;= 商家实收 &lt;
                        </Col>
                        <Col className="col-clear-all" span={2}>
                            <Input disabled />
                        </Col>
                        <Col className="col-clear-all" span={0.7}>
                            {`元/${periodType === FORM_TIP.PERIOD_M ? '月' : '日'}`}
                        </Col>
                        <Col className="col-clear-all" span={1.5}>
                            增量部分抽佣比例
                        </Col>
                        <Col className="col-clear-all" span={1}>
                            <Input disabled />
                        </Col>
                        <Col className="col-clear-all" span={0.5}>
                            %
                        </Col>
                        <Col className="col-clear-all" span={2} />
                    </Row>
                )}
            </div>
        );
    }
}
